<template>
  <div>
      
    <v-switch
      v-if="datosNew.length !== 0 && !$vuetify.breakpoint.mdAndUp"
      inset
      class="mx-1 mt-0"
      v-model="selectedItem"
      :label="`${verMontoCantidad ? 'Ver Montos' : 'Ver Cantidades'}`"
      color="#fe5000"
    ></v-switch>
    <v-data-iterator
      :items="visiblePages"
      disable-pagination
      hide-default-footer
      v-if="datosNew.length !== 0"
      v-show="$vuetify.breakpoint.smAndDown"
      :items-per-page="itemPage"
      :page.sync="page"
    >
      <template v-slot:default="props">
        <v-row>
          <v-col
            v-for="(item, j) in props.items"
            :key="j"
            cols="12"
            sm="6"
            md="4"
            lg="3"
          >
            <v-card class="v-cardgrid" rounded="md" max-width="450">
              <v-toolbar color="primary" dark flat dense>
                <span class="text-body-2 text-no-wrap"
                  >{{ `${item.Articulo} ` }}<br />
                  {{ `${item.NombreArt}` }}
                </span>
              </v-toolbar>
              <v-divider></v-divider>
              <v-list dense>
                <v-row no-gutters v-for="n in mesAnnio + 1" :key="n">
                  <v-col cols="4">
                    <v-card
                      class="
                        pa-2
                        ml-1
                        text-left
                        black--text
                        subtitle-2
                        font-weight-bold
                      "
                      flat
                    >
                      {{ MesNb(n) }}
                    </v-card>
                  </v-col>
                  <v-col cols="8">
                    <v-card
                      class="
                        pa-2
                        ml-1
                        text-right
                        mr-2
                        black--text
                        subtitle-2
                        font-weight-bold
                      "
                      flat
                      v-if="!verMontoCantidad"
                    >
                      {{
                        item.MontoMesExt[n - 1] != 0
                          ? simboloMoneda[tipoMoneda]
                          : ""
                      }}
                      {{ formatItem(item.MontoMesExt[n - 1]) | nocero }}
                    </v-card>
                    <v-card
                      class="
                        pa-2
                        ml-1
                        text-right
                        mr-2
                        black--text
                        subtitle-2
                        font-weight-bold
                      "
                      flat
                      v-if="verMontoCantidad"
                    >
                      {{ formatItem(item.UnidadesMes[n - 1]) | nocero }}
                    </v-card>
                  </v-col>
                </v-row>
              </v-list>
            </v-card>
          </v-col>
        </v-row>
      </template>
      <template v-slot:footer>
        <v-row class="ma-2" align="center" justify="center">
          <v-spacer></v-spacer>

          <span class="mr-3 title grey--text" v-if="numPage > 1">
            Pag {{ page }} de {{ numPage }}
          </span>
          <v-btn
            fab
            dark
            color="primary"
            class="mr-4"
            @click="formerPage"
            small
            v-if="numPage > 1"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn
            fab
            dark
            color="primary"
            class="mr-4"
            @click="nextPage"
            small
            v-if="numPage > 1"
          >
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-row>
      </template>
    </v-data-iterator>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  filters: {
    nocero: function (value) {
      return parseInt(value) != 0 ? value : "";
    },
  },
  data() {
    return {
      page: 1,
      itemsPerPage: 2,
      selected: 2,
      headersArt: [
        {
          text: "Articulo",
          align: "left",
          value: "Articulo",
          width: "170px",
          sortable: false,
          divider: true,
          class: "black--text subtitle-1 font-weight-bold d-print-none",
        },
        {
          text: "Nombre",
          align: "left",
          value: "NombreArt",
          width: "300px",
          sortable: false,
          divider: true,
          class: "black--text subtitle-1 font-weight-bold d-print-none",
        },

        {
          sortable: true,
          text: "Mes",
          class: "black--text subtitle-1 font-weight-bold d-print-none",
        },
      ],
    };
  },
  methods: {
    ...mapMutations("mod_cliente", ["set_verMontoCantidad"]),
    nextPage() {
      if (this.page + 1 <= this.numPage) {
        this.page += 1;
        //this.goTo();
      }
    },
    formerPage() {
      if (this.page - 1 >= 1) {
        this.page -= 1;
        //this.goTo();
      }
    },
    updateItemsPerPage(number) {
      this.page = 1;
      this.selected = number;
    },
    vAnnio() {
      var d = new Date();
      var n = d.getMonth();

      /* if (
        this.fechaA !=
        new Date().toLocaleString("sv", { timeZoneName: "short" }).substr(0, 4)
      )
        return 11;
      else */ return n;
    },
  },
  computed: {
    ...mapState("mod_cliente", ["wfVentasAno", "verMontoCantidad"]),
    ...mapState(["simboloMoneda", "tipoMoneda"]),
    selectedItem: {
      get() {
        return this.verMontoCantidad;
      },
      set() {
        this.set_verMontoCantidad();
      },
    },
    formatItem: function () {
      let numeral = require("numeral");
      //  return (val) => val <= 0.5 && val >= -0.49 ? numeral(val).format('0,0.00') : numeral(val).format("0,00");
      return (val) => numeral(val).format("0,00");
    },
    MesNb: function () {
      return function (fecha) {
        let mes = fecha;
        let cad = null;
        let meses = [
          "Ene",
          "Feb",
          "Mar",
          "Abr",
          "May",
          "Jun",
          "Jul",
          "Ago",
          "Sept",
          "Oct",
          "Nov",
          "Dic",
        ];
        cad = meses[parseInt(mes) - 1];

        return cad;
      };
    },
    mesAnnio() {
      var d = new Date();
      var n = d.getMonth();

      /* if (
        this.fechaA !=
        new Date().toLocaleString("sv", { timeZoneName: "short" }).substr(0, 4)
      )
        return 11;
      else */ return n;
    },
    itemPage() {
      return this.selected;
    },
    numPage() {
      return Math.ceil(
        this.wfVentasAno.datos.wfVentasAno.length / this.itemPage
      );
    },
    visiblePages() {
      let xDatos;
      if (Object.entries(this.wfVentasAno).length != 0) {
        xDatos = this.wfVentasAno.datos.wfVentasAno.slice(
          (this.page - 1) * this.itemPage,
          this.page * this.itemPage
        );
      }
      return xDatos;
    },
    datosNew() {
      let arr = [];
      if (Object.entries(this.wfVentasAno).length !== 0) {
        arr = this.wfVentasAno.datos.wfVentasAno;
      }
      return arr;
    },
  },
};
</script>

<style scoped>
.tbl_datos tr:nth-child(odd) {
  background: #ffffff;

  font-size: 11px;
  padding: 1px;
}
.tbl_datos tr:nth-child(even) {
  font-size: 11px;
  background: #e0e0e0;
  padding: 1px;
}

.v-cardgrid {
  background-color: #ffffff !important;

  border: 1px solid #002f6c !important;

  transition: opacity 0.4s ease-in-out;
  margin: 1px;
}
.v-list {
  height: 500px; /* or any height you want */
  overflow-y: auto;
}
</style>
